module.exports = __webpack_public_path__ + "static/media/lunas.a3af6d20.png";